import { z } from 'zod';

import { SlideItemType } from '../../../enums';

export const videoSlideItemSchema = z.object({
  type: z.literal(SlideItemType.VIDEO),
  assetRef: z.string().min(1),
});

export type VideoSlideItemType = z.infer<typeof videoSlideItemSchema>;
